module.exports = __webpack_public_path__ + "img/features-interface.a0b4a72c.svg";